import React from 'react';
import { Link as LinkIcon, X } from 'lucide-react';

const SnapshotToast = ({ isVisible, onClose, color = 'purple' }) => {

    const getColorClasses = (c) => {
        switch (c) {
            case 'yellow': return { border: 'border-yellow-500', bg: 'bg-yellow-50', icon: 'text-yellow-600' };
            case 'green': return { border: 'border-green-500', bg: 'bg-green-50', icon: 'text-green-600' };
            case 'blue': return { border: 'border-blue-500', bg: 'bg-blue-50', icon: 'text-blue-600' };
            case 'orange': return { border: 'border-orange-500', bg: 'bg-orange-50', icon: 'text-orange-600' };
            case 'purple': return { border: 'border-purple-500', bg: 'bg-purple-50', icon: 'text-purple-600' };
            default: return { border: 'border-purple-500', bg: 'bg-purple-50', icon: 'text-purple-600' };
        }
    };

    const styles = getColorClasses(color);

    return (
        <div className={`fixed bottom-24 md:bottom-28 left-1/2 transform -translate-x-1/2 w-[90%] md:w-auto max-w-md bg-white border-l-4 ${styles.border} rounded-lg shadow-2xl p-4 flex gap-4 transition-all duration-500 ease-in-out z-[100] ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0 pointer-events-none'}`}>
            <div className={`p-2 ${styles.bg} rounded-full h-fit shrink-0`}>
                <LinkIcon className={styles.icon} size={20} />
            </div>
            <div className="flex-1">
                <h3 className="font-bold text-slate-800 text-sm">Snapshot Copied!</h3>
                <p className="text-xs text-slate-500 mt-1 leading-relaxed">
                    This link captures your board exactly as it is right now. Pass the new link back and forth to collaborate!
                </p>
            </div>
            <button
                onClick={onClose}
                className="text-slate-400 hover:text-slate-600 h-fit"
            >
                <X size={16} />
            </button>
        </div>
    );
};

export default SnapshotToast;
